import type { StructuredToolInterface } from '@langchain/core/tools';
import { Scratchpad } from './scratchpad.js';
import { TokenCounter } from './token-counter.js';

/**
 * Mutable state for a single agent run.
 */
export interface RunContext {
  readonly query: string;
  readonly scratchpad: Scratchpad;
  readonly tokenCounter: TokenCounter;
  readonly startTime: number;
  iteration: number;
  /**
   * Input token count from the most recent API response.
   * This is the actual context size reported by the API — far more accurate
   * than character-based estimation. Used by manageContextThreshold() to
   * anchor token estimates on real data.
   */
  lastApiInputTokens: number;
  /**
   * MCP tools activated on demand by the `search_tools` tool during this run.
   * The agent loop merges these into the tool set bound to the LLM on the next
   * iteration, so only discovered MCP tools enter the context (never all of them).
   */
  activeMcpTools: StructuredToolInterface[];
  /** Optional account-health seed text surfaced by the preflight, if any. */
  accountSeed?: string;
}

export function createRunContext(query: string): RunContext {
  return {
    query,
    scratchpad: new Scratchpad(query),
    tokenCounter: new TokenCounter(),
    startTime: Date.now(),
    iteration: 0,
    lastApiInputTokens: 0,
    activeMcpTools: [],
  };
}
